import PriceBreakdown from './PriceBreakdown';

const DEFAULT_ROOMS = 1;
const UNKNOWN_NIGHTS = 0;

function toPositiveNumber(value, fallback) {
    const number = Number(value);
    return Number.isFinite(number) && number > 0 ? number : fallback;
}

// Mirrors how a deal card renders its price on the search results / hotel page: clients configured
// for total pricing see the whole stay, everyone else sees the per-room, per-night rate. `nights`
// and `rooms` are the caller's - the stay is a property of the search, not of this component - and
// a missing `nights` falls back to the total, since there is nothing to divide by then.
function getPriceBasis({ profile, company, deal, nights, rooms }) {
    const stay_nights = toPositiveNumber(nights, UNKNOWN_NIGHTS);
    const room_count = toPositiveNumber(rooms, DEFAULT_ROOMS);
    const show_total_price =
        !stay_nights ||
        !!PriceBreakdown.isShowTotalPrice({ profile, company }) ||
        PriceBreakdown.isBreakdownPrice({ profile, company, deal });

    return {
        nights: stay_nights,
        rooms: room_count,
        show_total_price,
        toDisplayedPrice: (total_price) =>
            show_total_price || !Number.isFinite(total_price) ? total_price : total_price / stay_nights / room_count,
    };
}

export { getPriceBasis };
